import { Component, OnInit, ViewChild } from '@angular/core';
import { FileSelectDirective, FileDropDirective, FileUploader, FileItem, FileLikeObject} from 'ng2-file-upload';
import { SecurityService } from '../../Core/Security/security.service';
import { LogService } from '../../Core/Abstract/log.service';
import { VisualsService } from '../../Core/Abstract/visuals.service';
import { Observable, throwError } from 'rxjs';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseUploaderComponent } from './baseUploader.component';
//If service needed
//import { RecFileUploadService } from './recFileUpload.service';

@Component({
    selector: 'baseAutoUploaderComponent',
    template: ''
})

export abstract class BaseAutoUploaderComponent extends BaseUploaderComponent{
        
    constructor(protected securityService: SecurityService,
                protected configService: ConfigService,
                protected logger: LogService,
                protected visualsService: VisualsService,
                protected eventsEmitterService: EventsEmitterService ) {

        super(securityService, configService, logger, visualsService, eventsEmitterService);
    }

    ngOnInit() {
        this.uploader.onBeforeUploadItem = (item) => {
            item.withCredentials = false;
        }
        this.uploader.onAfterAddingFile = (item) => { 
            this.quequeMsg = "" ;
            this.removeCustom(item);
            this.uploader.queue.push(item);
            //auto upload the item
            this.uploadCustom(item);
        };

        this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);
    }

}
